import { useEffect, useState }from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EyeIcon } from '@heroicons/react/24/solid'
import { EmptyValuePlaceholder } from "@/components/ui"
import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'
import { formatDate, formatPrice, formatSurface} from '@/utils/formatters'
import { setCurrentLocation } from '../../locations/locationsSlice'
import { setCurrentBien } from '../../biens/biensSlice'

const BienItem = ({ bien }) => {
  const dispatch = useDispatch()
  const archiveLoading = useSelector((state) => state.biens.loadingStatus.archive)
  const restoreLoading = useSelector((state) => state.biens.loadingStatus.restore)
  const requestError = useSelector((state) => state.biens.requestStatus.error)
  const [animating, setAnimating] = useState(false)
  const [pendingAction, setPendingAction] = useState(false)

  useEffect(() => {
    if (!archiveLoading && !restoreLoading && pendingAction) {
      if(!requestError) {
        setTimeout(() => {
          setAnimating(false)
          setPendingAction(false)
        }, 300) // Durée de l'animation
      } else {
        setAnimating(false)
        setPendingAction(false)
      }
    }
  }, [archiveLoading, restoreLoading])

  const handleRowClick = (bienId) => {
    window.location.href = `/biens/${bienId}` // Rediriger vers la page de détails du bien cliqué
  }

  return (
  <>
    <tr onClick={() => handleRowClick(bien.id)}
        data-object="bien" data-id={bien.id}
        className={`cursor-pointer text-sm hover:bg-primary-200 transition-all duration-500 ${
            animating ? 'opacity-50 transform scale-98 translate-x-2' 
            : 'opacity-100 transform scale-100'
        }`}
    >
      <td className="p-1">
        <div className={`flex items-center ${bien.archived_at && 'tooltip tooltip-right'}`}>
          {bien.archived_at && (
            <div className='tooltip-content'>
              archivé le {formatDate(bien.archived_at)}
            </div>
          )}
          <EmptyValuePlaceholder value={bien.codage_interne} />
          {bien.archived_at && (
            <div className="badge-container ml-2">
              <span className="badge badge-ghost px-3 py-3 text-xs">
                archivé
              </span>
            </div>
          )}
        </div>
      </td>
      <td className="p-1">
        <div className={`flex items-center ${bien.archived_at && 'tooltip tooltip-right'}`}>
          { bien.mandats.length < 2 && <EmptyValuePlaceholder value={bien.mandats[0]?.type_mandat} className='capitalize'/>  }
          { bien.mandats.length > 1 && 
              <div className='flex flex-col'>{
                bien.mandats.map((mandat, i) => <div key={i} className="capitalize">{mandat.type_mandat}</div>)
              }</div>
          }
        </div>
      </td>
      <td className="p-1">
        { bien.mandats.length < 2 && <EmptyValuePlaceholder value={bien.mandats[0]?.numero}/>  }
        { bien.mandats.length > 1 && (
            <div className='flex flex-col'>
              {
                bien.mandats.map((mandat, i) => (
                  <div key={i} className={`${mandat.actif ? "" : "italic"}`}>
                    {mandat.numero}
                    {!mandat.actif && <span className="ml-2">fin le {formatDate(mandat.date_fin)}</span>}
                  </div>
                )
                )
              }
            </div>
        )}
      </td>
      <td className="p-1"><EmptyValuePlaceholder value={formatPrice(bien.prix_vente || bien.prix_loyer)} /></td>
      <td className="p-1">
        <SingleLineAddressOnListing data={bien} />
      </td>
      <td className="p-1"><EmptyValuePlaceholder value={capitalize(bien.type_bien)} /></td>
      <td className="p-1"><EmptyValuePlaceholder value={formatSurface(bien.surface_carrez)} /></td>
      <td className="p-1">{ bien.proprietaires?.map((prop, i) => <div key={i} className="uppercase">{prop.nom_complet}</div>) }
      </td>
      <td className="p-1">{ Array.isArray(bien.locataires) 
        ? bien.locataires.map((loc, i) => <div key={i} className="uppercase">{loc.nom_complet}</div>) 
        : ""}
      </td>
      <td>
        { bien.location && (
          <div className="flex flex-col">
            <span>{bien.location.date_fin_bail ? "a loué du" : "loue depuis le"} {formatDate(bien.location.date_effet_bail)}</span>
            {bien.location.date_fin_bail && <span>au {formatDate(bien.location.date_fin_bail)}</span> }
          </div>
        )}
      </td>
      <td></td>
    </tr>
  </>
  )
}

export default BienItem